// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// Material UI
import { createTheme } from '@mui/material';



// ----------------------------------------------------------------------------
//   Main Custom Theme
// ----------------------------------------------------------------------------

const customTheme = createTheme({

  components: {

    // Set styles for Card elements
    MuiCard: {
      styleOverrides: {
        root: {

          // One entry per variant, add/override styles with CSS values
          variants: [

            // Base style
            {
              props: { },
              style: {
                // Stronger shadow & more rounded corners
                'boxShadow':    '0px 2px 4px rgb(0 0 0 / 25%)',
                'borderRadius': '6px',
              }
            },

            // Make `h="100%"` work properly
            {
              props: { 'h': '100%' },
              style: {
                'height':       '100%',
              }
            },
          ]
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          'borderRadius': '6px',
        },
      },
    }
  },
});



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export { customTheme };
